import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { computeSubscriptionStatus, addDays } from '../../utils/subscription';
import {
  totalEncaisse, countEncaisse, classementServices, pointJournalier,
  totalDepenses, totalDepensesParCategorie, benefice, applicationsSurMesure,
  repartitionParRubrique, 
  todayStr, monthStr, yearStr, 
} from '../../utils/finance';
import { fmt } from '../../utils/calc';
import './Modal.css';
import './AdminPanel.css';
import { initialData } from '../../data/initialData';
import { 
  updateMembreEquipe, 
  MembreEditor, 
  removeMembreEquipe, 
  addMembreEquipe 
} from '../sections/Equipe';

// ── Éditeur d'un tarif indicatif ─────────────────────────
function TiEditor({ ti, onChange, onRemove }) {
  const isNumeric = ti.fcfa != null;

  function toggleMode() {
    if (isNumeric) onChange({ ...ti, fcfa: null });
    else onChange({ ...ti, fcfa: 0 });
  }

  return (
    <div className="ti-edit-row" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 6 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          className="ti-edit-svc" style={{ flex: 1 }}
          value={ti.svc}
          onChange={e => onChange({ ...ti, svc: e.target.value })}
          placeholder="Service…"
        />
        <button className="ti-edit-del" onClick={onRemove}>✕</button>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--muted)' }}>
          <input type="checkbox" checked={isNumeric} onChange={toggleMode} style={{ width: 'auto' }} />
          Prix converti (FCFA/USD/EUR)
        </label>
        {isNumeric ? (
          <>
            <input
              type="number" min={0} className="ti-edit-prix" style={{ maxWidth: 140 }}
              value={ti.fcfa}
              onChange={e => onChange({ ...ti, fcfa: +e.target.value })}
              placeholder="Montant FCFA"
            />
            <input
              className="ti-edit-prix" style={{ maxWidth: 160 }}
              value={ti.unit || ''}
              onChange={e => onChange({ ...ti, unit: e.target.value })}
              placeholder="Unité (ex: page) — optionnel"
            />
          </>
        ) : (
          <input
            className="ti-edit-prix" style={{ flex: 1 }}
            value={ti.prix || ''}
            onChange={e => onChange({ ...ti, prix: e.target.value })}
            placeholder="Ex: Sur devis, 5–8%..."
          />
        )}
      </div>
    </div>
  );
}

// ── Éditeur d'un domaine (expandable) ────────────────────
function DomaineEditor({ d, onUpdate, onRemove }) {
  const [open, setOpen] = useState(false);
  const [local, setLocal] = useState({ ...d });

  function save() {
    onUpdate(local);
    showSuccessFlash();
  }
  const [saved, setSaved] = useState(false);
  function showSuccessFlash() { setSaved(true); setTimeout(() => setSaved(false), 1800); }

  function addSvc() { setLocal(l => ({ ...l, services: [...(l.services||[]), ''] })); }
  function setSvc(i, v) { setLocal(l => ({ ...l, services: l.services.map((s,j) => j===i ? v : s) })); }
  function removeSvc(i) { setLocal(l => ({ ...l, services: l.services.filter((_,j) => j!==i) })); }

  function addTi() { setLocal(l => ({ ...l, ti: [...(l.ti||[]), { svc:'', prix:'' }] })); }
  function setTi(i, v) { setLocal(l => ({ ...l, ti: l.ti.map((t,j) => j===i ? v : t) })); }
  function removeTi(i) { setLocal(l => ({ ...l, ti: l.ti.filter((_,j) => j!==i) })); }

  return (
    <div className={'dom-edit-card' + (open ? ' open' : '')}>
      <div className="dec-head" onClick={() => setOpen(v => !v)}>
        <span className="dec-icon">{local.icon}</span>
        <span className="dec-name">{local.name}</span>
        <div className="dec-head-right">
          <span className="dec-price">{local.price}</span>
          {open && (
            <button
              className="abtn abtn-red"
              style={{ fontSize: 10, padding: '3px 8px', marginLeft: 6 }}
              onClick={e => { e.stopPropagation(); if (window.confirm('Supprimer ce domaine ?')) onRemove(d.id); }}
            >
              🗑 Suppr.
            </button>
          )}
          <span className="dec-toggle">{open ? '▲' : '▼'}</span>
        </div>
      </div>

      {open && (
        <div className="dec-body">
          {/* Identité */}
          <div className="dec-section-label">Identité</div>
          <div className="grid2">
            <div className="fg2">
              <label>Icône (emoji)</label>
              <input value={local.icon} onChange={e => setLocal(l => ({ ...l, icon: e.target.value }))} placeholder="💻" style={{ fontSize: 20, textAlign: 'center' }} />
            </div>
            <div className="fg2">
              <label>Libellé Prix affiché</label>
              <input value={local.priceLabel || ''} onChange={e => setLocal(l => ({ ...l, priceLabel: e.target.value }))} placeholder="À partir de" />
            </div>
          </div>
          <div className="fg2">
            <label>Nom du domaine</label>
            <input value={local.name} onChange={e => setLocal(l => ({ ...l, name: e.target.value }))} />
          </div>
          <div className="fg2">
            <label>Description courte</label>
            <input value={local.desc} onChange={e => setLocal(l => ({ ...l, desc: e.target.value }))} />
          </div>
          <div className="dec-section-label" style={{ marginTop: 8 }}>Prix affiché en bas de carte</div>
<label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--muted)', marginBottom: 6 }}>
  <input
    type="checkbox" checked={local.priceFcfa != null} style={{ width: 'auto' }}
    onChange={() => setLocal(l => l.priceFcfa != null ? { ...l, priceFcfa: null } : { ...l, priceFcfa: 0 })}
  />
  Prix converti automatiquement (FCFA/USD/EUR)
</label>
{local.priceFcfa != null ? (
  <div className="fg2">
    <label>Montant (FCFA)</label>
    <input type="number" min={0} value={local.priceFcfa} onChange={e => setLocal(l => ({ ...l, priceFcfa: +e.target.value }))} />
  </div>
) : (
  <div className="fg2">
    <label>Texte libre (ex: Devis gratuit, Commission 5–8%)</label>
    <input value={local.price || ''} onChange={e => setLocal(l => ({ ...l, price: e.target.value }))} />
  </div>
)}

          {/* Services */}
          <div className="dec-section-label" style={{ marginTop: 12 }}>
            Services proposés
            <button className="dec-add-btn" onClick={addSvc}>+ Ajouter</button>
          </div>
          {(local.services || []).map((s, i) => (
            <div key={i} className="svc-edit-row">
              <input value={s} onChange={e => setSvc(i, e.target.value)} placeholder="Nom du service…" />
              <button onClick={() => removeSvc(i)}>✕</button>
            </div>
          ))}

          {/* Tarifs indicatifs */}
          <div className="dec-section-label" style={{ marginTop: 12 }}>
            Tarifs Indicatifs (TI)
            <button className="dec-add-btn" onClick={addTi}>+ Ajouter</button>
          </div>
          {(local.ti || []).map((t, i) => (
            <TiEditor key={i} ti={t} onChange={v => setTi(i, v)} onRemove={() => removeTi(i)} />
          ))}

          {/* Save */}
          <div style={{ marginTop: 14, display: 'flex', gap: 8, alignItems: 'center' }}>
            <button className="abtn abtn-blue" onClick={save}>✓ Enregistrer ce domaine</button>
            {saved && <span style={{ fontSize: 12, color: 'var(--green)' }}>✓ Sauvegardé !</span>}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Éditeur d'une formation (expandable) ─────────────────
function FormationEditor({ f, onUpdate, onRemove }) {
  const [open, setOpen] = useState(false);
  const [local, setLocal] = useState({ ...f });
  const [saved, setSaved] = useState(false);
 
  function save() {
    onUpdate(local);
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  }
 
  function addModule() { setLocal(l => ({ ...l, modules: [...(l.modules || []), ''] })); }
  function setModule(i, v) { setLocal(l => ({ ...l, modules: l.modules.map((m, j) => j === i ? v : m) })); }
  function removeModule(i) { setLocal(l => ({ ...l, modules: l.modules.filter((_, j) => j !== i) })); }
 
  return (
    <div className={'dom-edit-card' + (open ? ' open' : '')}>
      <div className="dec-head" onClick={() => setOpen(v => !v)}>
        <span className="dec-icon">{local.icon}</span>
        <span className="dec-name">{local.title}</span>
        <div className="dec-head-right">
          <span className="dec-price">
            {local.fcfa != null ? Number(local.fcfa).toLocaleString('fr-FR') + ' FCFA' : 'Sur devis'}
          </span>
          {open && (
            <button
              className="abtn abtn-red"
              style={{ fontSize: 10, padding: '3px 8px', marginLeft: 6 }}
              onClick={e => { e.stopPropagation(); if (window.confirm('Supprimer cette formation ?')) onRemove(f.id); }}
            >
              🗑 Suppr.
            </button>
          )}
          <span className="dec-toggle">{open ? '▲' : '▼'}</span>
        </div>
      </div>
 
      {open && (
        <div className="dec-body">
          <div className="dec-section-label">Identité</div>
          <div className="grid2">
            <div className="fg2">
              <label>Icône (emoji)</label>
              <input value={local.icon} onChange={e => setLocal(l => ({ ...l, icon: e.target.value }))} style={{ fontSize: 20, textAlign: 'center' }} />
            </div>
            <div className="fg2">
              <label>Durée</label>
              <input value={local.duree} onChange={e => setLocal(l => ({ ...l, duree: e.target.value }))} placeholder="Ex: 3 mois" />
            </div>
          </div>
          <div className="fg2">
            <label>Titre de la formation</label>
            <input value={local.title} onChange={e => setLocal(l => ({ ...l, title: e.target.value }))} />
          </div>
          <div className="grid2">
            <div className="fg2">
              <label>Places disponibles</label>
              <input value={local.places} onChange={e => setLocal(l => ({ ...l, places: e.target.value }))} placeholder="Ex: 15 places" />
            </div>
            <div className="fg2">
              <label>Mode</label>
              <input value={local.mode} onChange={e => setLocal(l => ({ ...l, mode: e.target.value }))} placeholder="Ex: Présentiel" />
            </div>
          </div>
 
          <div className="dec-section-label" style={{ marginTop: 12 }}>Tarification</div>
          <div className="fg2">
            <label>Prix (FCFA) — laisser vide pour afficher « Sur devis »</label>
            <input
              type="number" min={0}
              value={local.fcfa ?? ''}
              onChange={e => setLocal(l => ({ ...l, fcfa: e.target.value === '' ? null : +e.target.value }))}
              placeholder="Ex: 150000"
            />
          </div>
 
          <div className="dec-section-label" style={{ marginTop: 12 }}>
            Modules du programme
            <button className="dec-add-btn" onClick={addModule}>+ Ajouter</button>
          </div>
          {(local.modules || []).map((m, i) => (
            <div key={i} className="svc-edit-row">
              <input value={m} onChange={e => setModule(i, e.target.value)} placeholder="Nom du module…" />
              <button onClick={() => removeModule(i)}>✕</button>
            </div>
          ))}
 
          <div style={{ marginTop: 14, display: 'flex', gap: 8, alignItems: 'center' }}>
            <button className="abtn abtn-blue" onClick={save}>✓ Enregistrer cette formation</button>
            {saved && <span style={{ fontSize: 12, color: 'var(--green)' }}>✓ Sauvegardé !</span>}
          </div>
        </div>
      )}
    </div>
  );
}
// ── Éditeur d'un produit boutique (expandable) ───────────
function ProduitEditor({ p, onUpdate, onRemove }) {
  const [open, setOpen] = useState(false);
  const [local, setLocal] = useState({
    types: { achat: false, abonnement: true, entretien: false },
    essaiGratuit: false, essaiGratuitJours: 30, iconImage: '',
    ...p,
  });
  const [saved, setSaved] = useState(false);

  function save() {
    onUpdate(local);
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  }

  function handleDelete(e) {
    e.stopPropagation();
    if (window.confirm(`Supprimer définitivement le produit « ${p.name} » ? Cette action est irréversible.`)) {
      onRemove(p.id);
    }
  }

  function handleIconUpload(e) {
    const file = e.target.files[0];
    if (!file) return;
    const r = new FileReader();
    r.onload = ev => setLocal(l => ({ ...l, iconImage: ev.target.result }));
    r.readAsDataURL(file);
    e.target.value = '';
  }

  function toggleType(key) {
    setLocal(l => ({ ...l, types: { ...l.types, [key]: !l.types?.[key] } }));
  }

  return (
    <div className={'dom-edit-card' + (open ? ' open' : '')}>
      <div className="dec-head" onClick={() => setOpen(v => !v)}>
        {local.iconImage
          ? <img src={local.iconImage} alt="" style={{ width: 26, height: 26, borderRadius: 6, objectFit: 'cover' }} />
          : <span className="dec-icon">{local.icon}</span>}
        <span className="dec-name">{local.name}</span>
        <div className="dec-head-right">
          <span className="dec-price">
            {local.onDevis ? 'Sur devis' : `${Number(local.priceFcfa).toLocaleString('fr-FR')} FCFA`}
          </span>
          {!local.active && <span style={{ fontSize: 10, color: 'var(--red)', fontWeight: 700 }}>INACTIF</span>}
          {/* Actions toujours visibles, même carte fermée */}
          <button
            className="abtn abtn-blue"
            style={{ fontSize: 10, padding: '3px 8px' }}
            onClick={e => { e.stopPropagation(); setOpen(true); }}
            title="Modifier"
          >
            ✏️ Modifier
          </button>
          <button
            className="abtn abtn-red"
            style={{ fontSize: 10, padding: '3px 8px' }}
            onClick={handleDelete}
            title="Supprimer"
          >
            🗑 Suppr.
          </button>
          <span className="dec-toggle">{open ? '▲' : '▼'}</span>
        </div>
      </div>

      {open && (
        <div className="dec-body">
          <div className="dec-section-label">Identité</div>

          {/* Icône : image réelle OU emoji */}
          <div className="fg2">
            <label>Icône du produit</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {local.iconImage
                ? <img src={local.iconImage} alt="" style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--border)' }} />
                : <div style={{ width: 48, height: 48, borderRadius: 8, border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>{local.icon}</div>
              }
              <label className="abtn abtn-blue" style={{ fontSize: 11, cursor: 'pointer' }}>
                📷 Choisir une image
                <input type="file" accept="image/*" onChange={handleIconUpload} style={{ display: 'none' }} />
              </label>
              {local.iconImage && (
                <button className="abtn abtn-muted" style={{ fontSize: 11 }} onClick={() => setLocal(l => ({ ...l, iconImage: '' }))}>
                  Revenir à l'emoji
                </button>
              )}
            </div>
          </div>

          <div className="grid2">
            <div className="fg2">
              <label>Icône (emoji, utilisé si pas d'image)</label>
              <input value={local.icon} onChange={e => setLocal(l => ({ ...l, icon: e.target.value }))} style={{ fontSize: 20, textAlign: 'center' }} />
            </div>
            <div className="fg2">
              <label>Badge (optionnel)</label>
              <input value={local.badge || ''} onChange={e => setLocal(l => ({ ...l, badge: e.target.value }))} placeholder="Ex: Populaire" />
            </div>
          </div>
          <div className="fg2">
            <label>Nom du produit</label>
            <input value={local.name} onChange={e => setLocal(l => ({ ...l, name: e.target.value }))} />
          </div>
          <div className="fg2">
            <label>Description courte (carte boutique)</label>
            <input value={local.desc} onChange={e => setLocal(l => ({ ...l, desc: e.target.value }))} />
          </div>
          <div className="fg2">
            <label>Description détaillée (dépliable)</label>
            <textarea rows={3} value={local.longDesc || ''} onChange={e => setLocal(l => ({ ...l, longDesc: e.target.value }))} />
          </div>

          <div className="dec-section-label" style={{ marginTop: 12 }}>Mode(s) de vente</div>
          <p className="tab-desc" style={{ marginTop: -4 }}>
            Cochez tout ce qui s'applique : un produit peut être vendu en achat direct, en abonnement, et inclure de l'entretien à la fois.
          </p>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 10 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--muted)' }}>
              <input type="checkbox" checked={!!local.types?.achat} onChange={() => toggleType('achat')} style={{ width: 'auto' }} />
              🛍 Achat direct (paiement unique)
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--muted)' }}>
              <input type="checkbox" checked={!!local.types?.abonnement} onChange={() => toggleType('abonnement')} style={{ width: 'auto' }} />
              🔁 Abonnement récurrent
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--muted)' }}>
              <input type="checkbox" checked={!!local.types?.entretien} onChange={() => toggleType('entretien')} style={{ width: 'auto' }} />
              🛠 Entretien / support inclus
            </label>
          </div>

          <div className="dec-section-label" style={{ marginTop: 12 }}>Tarification</div>
          <div className="grid3">
            <div className="fg2">
              <label>Prix (FCFA)</label>
              <input type="number" value={local.priceFcfa} onChange={e => setLocal(l => ({ ...l, priceFcfa: +e.target.value }))} />
            </div>
            <div className="fg2">
              <label>Prix max (FCFA)</label>
              <input type="number" value={local.priceFcfaMax || 0} onChange={e => setLocal(l => ({ ...l, priceFcfaMax: +e.target.value }))} />
            </div>
            <div className="fg2">
              <label>Unité de facturation</label>
              <select value={local.unit} onChange={e => setLocal(l => ({ ...l, unit: e.target.value }))}>
                <option value="mois">Par mois (abonnement récurrent)</option>
                <option value="unique">Paiement unique (achat direct)</option>
                <option value="analyse">À l'usage — prix par analyse/utilisation ponctuelle</option>
                <option value="devis">Sur devis (pas d'achat direct en ligne)</option>
              </select>
            </div>
          </div>
          <p className="tab-desc" style={{ marginTop: -4 }}>
            💡 <strong>« À l'usage / analyse »</strong> sert aux prestations facturées par utilisation unitaire
            (ex : une vérification anti-plagiat, un rapport, une analyse) plutôt qu'un abonnement mensuel :
            le client paie « Prix × nombre d'utilisations » ajoutées au panier, sans engagement récurrent.
          </p>

          {local.types?.abonnement && (
            <>
              <div className="dec-section-label" style={{ marginTop: 12 }}>Essai gratuit &amp; suivi d'abonnement</div>
              <div className="grid2">
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--muted)' }}>
                  <input type="checkbox" checked={!!local.essaiGratuit} onChange={e => setLocal(l => ({ ...l, essaiGratuit: e.target.checked }))} style={{ width: 'auto' }} />
                  🎁 Offrir 1 mois d'essai gratuit à la souscription
                </label>
                <div className="fg2" style={{ marginBottom: 0 }}>
                  <label>Durée de l'essai (jours)</label>
                  <input type="number" min={0} value={local.essaiGratuitJours ?? 30}
                    disabled={!local.essaiGratuit}
                    onChange={e => setLocal(l => ({ ...l, essaiGratuitJours: +e.target.value }))} />
                </div>
              </div>
              <p className="tab-desc" style={{ marginTop: 4 }}>
                À la commande, la date de prochain paiement est calculée automatiquement (fin d'essai, puis tous les 30 jours).
                Voir la section <strong>« 📅 Abonnements à surveiller »</strong> ci-dessus pour détecter les impayés et suspendre l'accès.
              </p>
            </>
          )}

          <div className="grid2" style={{ marginTop: 8 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--muted)' }}>
              <input type="checkbox" checked={!!local.onDevis} onChange={e => setLocal(l => ({ ...l, onDevis: e.target.checked }))} style={{ width: 'auto' }} />
              Uniquement sur devis (masque « Acheter »)
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--muted)' }}>
              <input type="checkbox" checked={local.active !== false} onChange={e => setLocal(l => ({ ...l, active: e.target.checked }))} style={{ width: 'auto' }} />
              Visible dans la boutique
            </label>
          </div>

          <div style={{ marginTop: 14, display: 'flex', gap: 8, alignItems: 'center' }}>
            <button className="abtn abtn-blue" onClick={save}>✓ Enregistrer ce produit</button>
            <button className="abtn abtn-red" onClick={handleDelete}>🗑 Supprimer ce produit</button>
            {saved && <span style={{ fontSize: 12, color: 'var(--green)' }}>✓ Sauvegardé !</span>}
          </div>
        </div>
      )}
    </div>
  );
}


export default function AdminPanel({ onClose }) {
  const { data, updateData, adminPwd, setAdminPwd, showToast, updateTransaction, saveDepense, deleteDepense } = useApp();
  const [tab, setTab] = useState('domaines');
  const [filtreVisitesPeriode, setFiltreVisitesPeriode] = useState('tout');
  const [filtreVisitesType,    setFiltreVisitesType]    = useState('clients');

  /* ── Mot de passe ── */
  const [pwdCur, setPwdCur] = useState('');
  const [pwdNew, setPwdNew] = useState('');
  const [pwdCf,  setPwdCf]  = useState('');
  const [pwdMsg, setPwdMsg] = useState({ txt: '', ok: true });

  function changePwd() {
    if (pwdCur !== adminPwd) { setPwdMsg({ txt: 'Code actuel incorrect.', ok: false }); return; }
    if (pwdNew.length < 4)   { setPwdMsg({ txt: 'Minimum 4 caractères.', ok: false }); return; }
    if (pwdNew !== pwdCf)    { setPwdMsg({ txt: 'Les codes ne correspondent pas.', ok: false }); return; }
    setAdminPwd(pwdNew);
    setPwdMsg({ txt: '✓ Code administrateur modifié !', ok: true });
    setPwdCur(''); setPwdNew(''); setPwdCf('');
  }

  /* ── Ouvriers ── */
  const [nwName,  setNwName]  = useState('');
  const [nwRole,  setNwRole]  = useState('ouvrier');
  const [nwPwd,   setNwPwd]   = useState('');
  const [nwEmail, setNwEmail] = useState('');

  function addWorker() {
    if (!nwName.trim() || !nwPwd.trim()) { showToast('Nom et code requis', 'err'); return; }
    updateData({ workers: [...data.workers, { id: Date.now(), name: nwName.trim(), role: nwRole, pwd: nwPwd.trim(), email: nwEmail.trim() }] });
    setNwName(''); setNwPwd(''); setNwEmail('');
    showToast(nwName + ' ajouté');
  }
  function removeWorker(id) {
    if (window.confirm('Supprimer cet ouvrier ?'))
      updateData({ workers: data.workers.filter(w => w.id !== id) });
  }
  function editWorkerPwd(id, name) {
    const np = window.prompt('Nouveau code pour ' + name + ' :', '');
    if (np && np.trim().length >= 2) {
      updateData({ workers: data.workers.map(w => w.id === id ? { ...w, pwd: np.trim() } : w) });
      showToast('Code de ' + name + ' modifié');
    }
  }

  /* ── Domaines ── */
  function updateDomaine(updated) {
    updateData({ domaines: data.domaines.map(d => d.id === updated.id ? { ...d, ...updated } : d) });
    showToast('Domaine mis à jour !');
  }
  function removeDomaine(id) {
    updateData({ domaines: data.domaines.filter(d => d.id !== id) });
    showToast('Domaine supprimé.', 'warn');
  }
  function addDomaine() {
    const nd = {
      id: Date.now(), icon: '🆕', name: 'Nouveau domaine',
      desc: 'Description du domaine', services: ['Service 1'],
      ti: [{ svc: 'Prestation', prix: 'Sur devis' }],
      images: [], price: 'Sur devis', priceLabel: '',
    };
    updateData({ domaines: [...data.domaines, nd] });
    showToast('Domaine créé — cliquez pour éditer.');
  }

  /* ── Formations ── */
function updateFormation(updated) {
  updateData({ formations: data.formations.map(f => f.id === updated.id ? { ...f, ...updated } : f) });
  showToast('Formation mise à jour !');
}
function removeFormation(id) {
  updateData({ formations: data.formations.filter(f => f.id !== id) });
  showToast('Formation supprimée.', 'warn');
}
function addFormation() {
  const nf = {
    id: Date.now(), icon: '🆕', title: 'Nouvelle formation',
    duree: '1 mois', places: '10 places', mode: 'Présentiel',
    modules: ['Module 1'], fcfa: 50000,
  };
  updateData({ formations: [...data.formations, nf] });
  showToast('Formation créée — cliquez pour éditer.');
}

// eslint-disable-next-line no-unused-vars
  function reinitialiserDomainesEtFormations() {
  if (window.confirm(
    'Ceci va remplacer TOUS les domaines et formations actuels par les valeurs par défaut du code (avec les nouveaux champs de devise USD/EUR). Toute modification manuelle faite depuis l\'admin sera perdue. Continuer ?'
  )) {
    updateData({
      domaines:   initialData.domaines,
      formations: initialData.formations,
    });
    showToast('Domaines et formations réinitialisés avec les nouveaux champs de devise !', 'ok');
  }
}

  /* ── Produits boutique (KotosShop) ── */
  function updateProduit(updated) {
    updateData({ produits: (data.produits || []).map(p => p.id === updated.id ? { ...p, ...updated } : p) });
    showToast('Produit mis à jour !');
  }
  function removeProduit(id) {
    updateData({ produits: (data.produits || []).filter(p => p.id !== id) });
    showToast('Produit supprimé.', 'warn');
  }
  function addProduit() {
    const np = {
      id: Date.now(), icon: '🆕', name: 'Nouveau produit',
      desc: 'Description courte', longDesc: 'Description détaillée du produit.',
      category: 'SaaS', priceFcfa: 15000, priceFcfaMax: 15000, unit: 'mois',
      badge: '', active: true, onDevis: false,
    };
    updateData({ produits: [...(data.produits || []), np] });
    showToast('Produit créé — cliquez pour éditer.');
  }

  /* ── Commandes boutique (transactions type='commande') ── */
  const commandes = (data.transactions || []).filter(t => t.type === 'commande');
  const cmdCA = commandes.filter(c => c.fedapay_status === 'approved').reduce((s, c) => s + c.total, 0);
  const cmdPayees = commandes.filter(c => c.fedapay_status === 'approved').length;
  const cmdEnAttente = commandes.filter(c => c.fedapay_status !== 'approved').length;

  /* ── Abonnements : détection auto + actions manuelles ── */
  const graceDays = data.boutiqueConfig?.delaiGraceJours ?? 3;
  const [graceDraft, setGraceDraft] = useState(graceDays);
  const commissionPct = data.boutiqueConfig?.commissionMarketplacePct ?? 10;
  const [commissionDraft, setCommissionDraft] = useState(commissionPct);
  const abonnements = commandes.filter(c => c.abonnement);

  /* ── Sous-comptes FedaPay (marketplace) ── */
  const FUNCTIONS_BASE = process.env.REACT_APP_FUNCTIONS_BASE_URL || 'https://europe-west1-VOTRE_PROJET.cloudfunctions.net';
  const KOTOS_API_KEY  = process.env.REACT_APP_KOTOS_API_KEY;
  const [inviting, setInviting] = useState(null); // id de la commande en cours d'invitation
  const [refDrafts, setRefDrafts] = useState({}); // { [commandeId]: valeur saisie manuellement }
  const [acceptModalFor, setAcceptModalFor] = useState(null); // commande en attente d'acceptation des conditions
  const [acceptChecked, setAcceptChecked] = useState(false);

  async function inviterSousCompte(c) {
    if (!c.cemail && !c.ctel) { showToast("Ce client n'a ni email ni téléphone enregistré.", 'err'); return; }
    setInviting(c.id);
    try {
      const resp = await fetch(`${FUNCTIONS_BASE}/inviteFedapaySubAccount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          apiKey: KOTOS_API_KEY, commandeId: c.id,
          email: c.cemail || `${(c.ctel || '').replace(/\D/g, '')}@clients.kotostechnology.com`,
          fullName: c.cnom || 'Client KotosTechnology',
        }),
      });
      const data2 = await resp.json();
      if (data2.ok) {
        showToast(data2.reference ? `Sous-compte créé : ${data2.reference}` : "Invitation envoyée — en attente d'acceptation du client.", 'ok');
      } else {
        showToast(data2.error || "Échec de l'invitation.", 'err');
      }
    } catch (e) {
      showToast('Service indisponible (vérifiez FUNCTIONS_BASE).', 'err');
    }
    setInviting(null);
  }

  function ouvrirAcceptation(c) {
    setAcceptChecked(false);
    setAcceptModalFor(c);
  }

  async function confirmerAcceptationEtInviter() {
    const c = acceptModalFor;
    if (!c || !acceptChecked) return;
    await updateTransaction(c.id, {
      commissionAcceptedAt: new Date().toISOString(),
      commissionAcceptedRate: commissionPct,
    });
    setAcceptModalFor(null);
    await inviterSousCompte(c);
  }

  function enregistrerRefManuelle(c) {
    const ref = (refDrafts[c.id] || '').trim();
    if (!ref) { showToast('Entrez une référence (ex: acc_xxxxxxxxx).', 'warn'); return; }
    updateTransaction(c.id, { subAccountRef: ref, subAccountStatut: 'valide' });
    showToast('Référence enregistrée pour ce client.', 'ok');
  }

  /* ── 📊 Finances — encaissements, dépenses, bénéfice, classement ── */
  const fJour  = todayStr();
  const fMois  = monthStr();
  const fAnnee = yearStr();

  const encJour  = totalEncaisse(data.transactions, { day: fJour });
  const encMois  = totalEncaisse(data.transactions, { month: fMois });
  const encAnnee = totalEncaisse(data.transactions, { year: fAnnee });
  const nbEncMois = countEncaisse(data.transactions, { month: fMois });

  const depMois  = totalDepenses(data.depenses, { month: fMois });
  const depAnnee = totalDepenses(data.depenses, { year: fAnnee });
  const depParCatMois = totalDepensesParCategorie(data.depenses, { month: fMois });

  const beneficeMois  = benefice(data.transactions, data.depenses, { month: fMois });
  const beneficeAnnee = benefice(data.transactions, data.depenses, { year: fAnnee });

  const classementMois  = classementServices(data.transactions, { month: fMois });
  const classementAnnee = classementServices(data.transactions, { year: fAnnee });
  const journalierMois  = pointJournalier(data.transactions, fMois);
  const surMesure = applicationsSurMesure(data.transactions);

  const repartitionMois  = repartitionParRubrique(data.transactions, { month: fMois });
  const repartitionAnnee = repartitionParRubrique(data.transactions, { year: fAnnee });
  const [vueRepartition, setVueRepartition] = useState('mois'); // 'mois' | 'annee'
   
  
  // Protection locale — NE PAS mettre de return ici !
  const repartitionActive = (vueRepartition === 'mois' ? repartitionMois : repartitionAnnee)
    ? (repartitionMois  || { buckets: {}, total: 0 })
    : (repartitionAnnee || { buckets: {}, total: 0 });
  
  const [depForm, setDepForm] = useState({ categorie: 'personnel', libelle: '', montant: '', date: fJour });
  function ajouterDepense() {
    if (!depForm.libelle || !depForm.montant) { showToast('Libellé et montant requis.', 'warn'); return; }
    saveDepense({ ...depForm, montant: Number(depForm.montant) });
    setDepForm({ categorie: 'personnel', libelle: '', montant: '', date: fJour });
    showToast('Dépense enregistrée.', 'ok');
  }
  function supprimerDepense(id) {
    if (window.confirm('Supprimer cette dépense ?')) deleteDepense(id);
  }

  /* ── 👥 Visiteurs (analytics anonymisées) ── */

// ── Séparer visites clients et équipe interne ──────────────
const toutesVisites  = data.visites || [];
const visitesClients = toutesVisites.filter(v => v.type !== 'interne' && v.type !== 'visiteur_admin');
const visitesEquipe  = toutesVisites.filter(v => v.type === 'interne' || v.type === 'visiteur_admin');

// ── Stats clients ───────────────────────────────────────────
const visitesJour  = visitesClients.filter(v => v.dateStr === fJour).length;
const visitesMois  = visitesClients.filter(v => v.dateStr?.startsWith(fMois)).length;
const visitesTotal = visitesClients.length;

// ── Stats équipe ────────────────────────────────────────────
const equipeJour  = visitesEquipe.filter(v => v.dateStr === fJour).length;
const equipeMois  = visitesEquipe.filter(v => v.dateStr?.startsWith(fMois)).length;
const equipeTotal = visitesEquipe.length;

// ── Pays (clients uniquement) ───────────────────────────────
const visitesParPays = {};
visitesClients.forEach(v => {
  const pays = v.pays || 'Inconnu';
  visitesParPays[pays] = (visitesParPays[pays] || 0) + 1;
});
const paysTop = Object.entries(visitesParPays).sort((a, b) => b[1] - a[1]).slice(0, 8);

// ── Membres équipe actifs ────────────────────────────────────
const equipeParMembre = {};
visitesEquipe.forEach(v => {
  const nom = v.membre || v.type || 'Inconnu';
  equipeParMembre[nom] = (equipeParMembre[nom] || 0) + 1;
});

  function filtrerParPeriode(visites, periode) {
  if (periode === 'jour')  return visites.filter(v => v.dateStr === fJour);
  if (periode === 'mois')  return visites.filter(v => v.dateStr?.startsWith(fMois));
  if (periode === 'annee') return visites.filter(v => v.dateStr?.startsWith(fAnnee));
  return visites; // 'tout'
}

const clientsFiltres = filtrerParPeriode(visitesClients, filtreVisitesPeriode);
const equipeFiltree  = filtrerParPeriode(visitesEquipe,  filtreVisitesPeriode);

  function suspendreAbo(c) {
    if (window.confirm(`Suspendre l'accès de ${c.cnom} pour cette application ? Le client ne pourra plus utiliser le service tant que le compte n'est pas réactivé.`)) {
      updateTransaction(c.id, { statutAbonnement: 'suspendu' });
      showToast('Abonnement suspendu.', 'warn');
    }
  }
  function reactiverAbo(c) {
    updateTransaction(c.id, {
      statutAbonnement: 'actif',
      dateProchainPaiement: addDays(new Date().toISOString().split('T')[0], 30),
    });
    showToast('Abonnement réactivé pour 30 jours.', 'ok');
  }
  function renouvelerAbo(c) {
    updateTransaction(c.id, {
      statutAbonnement: 'actif',
      dateProchainPaiement: addDays(c.dateProchainPaiement || new Date().toISOString().split('T')[0], 30),
    });
    showToast('Paiement enregistré, abonnement prolongé de 30 jours.', 'ok');
  }

  /* ── Export / Import ── */
  function exportData() {
    const ex = { ...data, domaines: data.domaines.map(d => ({ ...d, images: [] })), transactions: data.transactions };
    const blob = new Blob([JSON.stringify(ex, null, 2)], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'kotostechnology-data.json';
    a.click();
  }
  function importData(e) {
    const file = e.target.files[0];
    if (!file) return;
    const r = new FileReader();
    r.onload = ev => {
      try { updateData(JSON.parse(ev.target.result)); showToast('Données importées'); }
      catch { showToast('Fichier invalide', 'err'); }
    };
    r.readAsText(file);
  }

  /* ── Contact & Paiement ── */
  const [contact,  setContact]  = useState({ ...data.contact });
  const [paiement, setPaiement] = useState({ ...data.paiement });

  /* ── Photos ── */
  const [peCaption, setPeCaption] = useState('');
  const [peCat,     setPeCat]     = useState('Équipe');
  const [pdDomaine, setPdDomaine] = useState(data.domaines[0]?.id || 1);
  const [pdCaption, setPdCaption] = useState('');

  function addPhotoEntreprise(e) {
    Array.from(e.target.files).forEach(file => {
      const r = new FileReader();
      r.onload = ev => {
        const ph = { id: Date.now() + Math.random(), data: ev.target.result, caption: peCaption.trim(), categorie: peCat };
        updateData({ photosEntreprise: [...(data.photosEntreprise || []), ph] });
        showToast('Photo ajoutée !');
      };
      r.readAsDataURL(file);
    });
    e.target.value = '';
  }
  function removePhotoEnt(id) {
    updateData({ photosEntreprise: (data.photosEntreprise || []).filter(p => p.id !== id) });
    showToast('Photo supprimée.', 'warn');
  }
  function movePEnt(id, dir) {
    const arr = [...(data.photosEntreprise || [])];
    const i = arr.findIndex(p => p.id === id);
    if (i < 0) return;
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    updateData({ photosEntreprise: arr });
  }
  function addPhotoDomaine(e) {
    Array.from(e.target.files).forEach(file => {
      const r = new FileReader();
      r.onload = ev => {
        const ph = { id: Date.now() + Math.random(), data: ev.target.result, caption: pdCaption.trim() };
        updateData({ domaines: data.domaines.map(d => d.id === +pdDomaine ? { ...d, images: [...(d.images || []), ph] } : d) });
        showToast('Photo domaine ajoutée !');
      };
      r.readAsDataURL(file);
    });
    e.target.value = '';
  }
  function removePhotoDom(domaineId, imgId) {
    updateData({ domaines: data.domaines.map(d => d.id === domaineId ? { ...d, images: (d.images || []).filter(i => i.id !== imgId) } : d) });
    showToast('Photo supprimée.', 'warn');
  }

  /* ── Tabs ── */
  const tabs = [
    ['equipe',    '🧑‍🤝‍🧑 Équipe'],
    ['domaines',    '🏢 Domaines'],
    ['formations',  '🎓 Formations'],
    ['boutique',    '🛒 Boutique'],
    ['digitalisation', '🌐 Digitalisation'],
    ['finances',    '📊 Finances'],
    ['visiteurs',   '👥 Visiteurs'],
    ['workers',     '👷 Ouvriers'],
    ['contact',     '📞 Contact'],
    ['paiement',    '💳 Paiement'],
    ['photos_ent',  '📸 Photos Entrep.'],
    ['photos_dom',  '🖼 Photos Domaines'],
    ['pwd',         '🔐 Accès'],
    ['export',      '💾 Données'],
  ];

  return (
    <>
    <div className="overlay open">
      <div className="modal adm-panel">
        <div className="adm-head">
          <h2>⚙ Administration KOTOSTECHNOLOGY</h2>
          <button className="mclose" onClick={onClose}>✕</button>
        </div>
        <div className="adm-body">

          {/* Sidebar */}
          <div className="adm-sidebar">
            {tabs.map(([id, label]) => (
              <div key={id} className={'atab' + (tab === id ? ' active' : '')} onClick={() => setTab(id)}>
                {label}
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="adm-content">

            {/* ══ ÉQUIPE ══ */}
            {tab === 'equipe' && (
              <div>
                <h3>🧑‍🤝‍🧑 Gestion de l'Équipe</h3>
                <p className="tab-desc">
                  Modifiez les informations sur les membres de l'équipe : nom, poste, compétences, et photos.
                </p>
                {(data?.equipe || []).map((membre) => (
                  <MembreEditor
                    key={membre.id}
                    m={membre}
                    onUpdate={updateMembreEquipe}
                    onRemove={removeMembreEquipe}
                  />
                ))}

                <button className="abtn abtn-green" style={{ marginBottom: 14 }} onClick={addMembreEquipe}>
                  + Ajouter un nouveau membre
                </button>
              </div>
            )}

            {/* ══ DOMAINES ══ */}
            {tab === 'domaines' && (
              <div>
                <h3>🏢 Gestion des Domaines</h3>
                <p className="tab-desc">
                  Modifiez chaque domaine : icône, nom, description, services proposés, tarifs indicatifs et prix affiché.
                  Cliquez sur un domaine pour le déplier et modifier.
                </p>
                <button className="abtn abtn-green" style={{ marginBottom: 14 }} onClick={addDomaine}>
                  + Ajouter un nouveau domaine
                </button>

{/*/<button
  className="abtn abtn-gold"
  style={{ marginBottom: 14, marginLeft: 8 }}
  onClick={reinitialiserDomainesEtFormations}
>
  🔄 Réinitialiser domaines & formations (nouveaux champs devise)
</button>*/}

                {data.domaines.map(d => (
                  <DomaineEditor
                    key={d.id}
                    d={d}
                    onUpdate={updateDomaine}
                    onRemove={removeDomaine}
                  />
                ))}
              </div>
            )}

            {/* ══ FORMATIONS ══ */}
            {tab === 'formations' && (
              <div>
                <h3>🎓 Gestion des Formations</h3>
                <p className="tab-desc">
                  Modifiez chaque formation : icône, durée, places, mode, modules du programme et prix.
                  Laissez le prix vide pour afficher « Sur devis ».
                </p>
                <button className="abtn abtn-green" style={{ marginBottom: 14 }} onClick={addFormation}>
                  + Ajouter une nouvelle formation
                </button>
                {data.formations.map(f => (
                  <FormationEditor
                    key={f.id}
                    f={f}
                    onUpdate={updateFormation}
                    onRemove={removeFormation}
                  />
                ))}
              </div>
            )}

            {/* ══ BOUTIQUE (KotosShop) ══ */}
            {tab === 'boutique' && (
              <div>
                <h3>🛒 Boutique KotosShop</h3>
                <p className="tab-desc">
                  Gérez le catalogue d'applications vendues en ligne (prix, description, disponibilité)
                  et suivez les commandes payées via FedaPay.
                </p>

                {/* Stats commandes */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 20 }}>
                  {[
                    { label: 'Chiffre d\'affaires boutique', value: cmdCA.toLocaleString('fr-FR') + ' FCFA', color: '#00CC88', icon: '💵' },
                    { label: 'Commandes payées', value: cmdPayees, color: '#00BFFF', icon: '✅' },
                    { label: 'En attente / non finalisées', value: cmdEnAttente, color: '#D4A017', icon: '⏳' },
                  ].map((s, i) => (
                    <div key={i} style={{ background: 'rgba(13,27,62,0.6)', border: `1px solid ${s.color}33`, borderRadius: 10, padding: 14, textAlign: 'center' }}>
                      <div style={{ fontSize: 20, marginBottom: 4 }}>{s.icon}</div>
                      <div style={{ fontSize: 18, fontWeight: 900, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Liste des commandes */}
                <div className="dec-section-label" style={{ marginBottom: 8 }}>📦 Dernières commandes</div>
                {commandes.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 24, color: 'var(--muted)', fontSize: 13, background: 'rgba(255,255,255,0.02)', borderRadius: 10, marginBottom: 20 }}>
                    Aucune commande pour le moment. Les achats faits depuis la boutique apparaîtront ici.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
                    {commandes.slice(0, 12).map(c => {
                      const ok = c.fedapay_status === 'approved';
                      return (
                        <div key={c.id} style={{ background: 'rgba(13,27,62,0.5)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                          <span style={{ background: ok ? 'rgba(0,204,136,0.15)' : 'rgba(212,160,23,0.15)', color: ok ? '#00CC88' : '#D4A017', fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 6 }}>
                            {ok ? '✅ Payée' : '⏳ Non payée'}
                          </span>
                          <div style={{ flex: 1, minWidth: 140 }}>
                            <div style={{ fontWeight: 700, fontSize: 13 }}>{c.client}</div>
                            <div style={{ fontSize: 11, color: 'var(--muted)' }}>{c.num} · {c.dateStr}</div>
                          </div>
                          <div style={{ fontSize: 14, fontWeight: 900, color: 'var(--gold)' }}>
                            {Number(c.total).toLocaleString('fr-FR')} FCFA
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Réglage du délai de grâce */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, background: 'rgba(0,191,255,0.05)', border: '1px solid rgba(0,191,255,0.2)', borderRadius: 8, padding: '10px 14px' }}>
                  <label style={{ fontSize: 13, color: 'var(--muted)', fontWeight: 700, flexShrink: 0 }}>⏳ Délai de grâce avant suspension (jours)</label>
                  <input
                    type="number" min={0} max={30}
                    value={graceDraft}
                    onChange={e => setGraceDraft(+e.target.value)}
                    style={{ width: 70 }}
                  />
                  <button
                    className="abtn abtn-blue"
                    style={{ fontSize: 11, padding: '6px 12px' }}
                    onClick={() => {
                      updateData({ boutiqueConfig: { ...data.boutiqueConfig, delaiGraceJours: graceDraft } });
                      showToast(`Délai de grâce réglé à ${graceDraft} jour(s).`, 'ok');
                    }}
                  >
                    ✓ Appliquer
                  </button>
                  <span style={{ fontSize: 11, color: 'var(--muted)' }}>Actuel : {graceDays} j</span>
                </div>

                {/* Réglage de la commission marketplace */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20, background: 'rgba(0,204,136,0.05)', border: '1px solid rgba(0,204,136,0.2)', borderRadius: 8, padding: '10px 14px' }}>
                  <label style={{ fontSize: 13, color: 'var(--muted)', fontWeight: 700, flexShrink: 0 }}>💰 Commission KotosTechnology (marketplace, %)</label>
                  <input
                    type="number" min={0} max={100}
                    value={commissionDraft}
                    onChange={e => setCommissionDraft(+e.target.value)}
                    style={{ width: 70 }}
                  />
                  <button
                    className="abtn abtn-green"
                    style={{ fontSize: 11, padding: '6px 12px' }}
                    onClick={() => {
                      updateData({ boutiqueConfig: { ...data.boutiqueConfig, commissionMarketplacePct: commissionDraft } });
                      showToast(`Commission réglée à ${commissionDraft}%.`, 'ok');
                    }}
                  >
                    ✓ Appliquer
                  </button>
                  <span style={{ fontSize: 11, color: 'var(--muted)' }}>Actuel : {commissionPct}%</span>
                </div>

                {/* Sous-comptes FedaPay (marketplace) — paiements directs des clients */}
                <div className="dec-section-label" style={{ marginBottom: 4 }}>🔗 Sous-comptes FedaPay (paiements directs des clients)</div>
                <p className="tab-desc" style={{ marginTop: -2 }}>
                  Pour qu'un client reçoive directement l'argent de SES propres clients (ex: via l'app
                  Gestion Voyages ou E-commerce), invitez-le comme sous-compte FedaPay Marketplace.
                  Nécessite que votre compte principal soit passé en « Compte Marketplace » chez FedaPay.
                </p>
                {commandes.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 20, color: 'var(--muted)', fontSize: 13, background: 'rgba(255,255,255,0.02)', borderRadius: 10, marginBottom: 20 }}>
                    Aucun client pour le moment.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
                    {commandes.map(c => (
                      <div key={c.id} style={{ background: 'rgba(13,27,62,0.5)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '10px 14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: c.subAccountRef ? 0 : 8 }}>
                          <div style={{ flex: 1, minWidth: 140 }}>
                            <div style={{ fontWeight: 700, fontSize: 13 }}>{c.cnom}</div>
                            <div style={{ fontSize: 11, color: 'var(--muted)' }}>{c.cemail || c.ctel}</div>
                          </div>
                          {c.subAccountRef ? (
                            <span style={{ background: 'rgba(0,204,136,0.15)', color: '#00CC88', fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 6 }}>
                              ✅ {c.subAccountRef}
                            </span>
                          ) : c.subAccountStatut === 'invite' ? (
                            <span style={{ background: 'rgba(212,160,23,0.15)', color: '#D4A017', fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 6 }}>
                              ⏳ Invitation envoyée
                            </span>
                          ) : (
                            <span style={{ background: 'rgba(255,255,255,0.06)', color: 'var(--muted)', fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 6 }}>
                              — Non configuré
                            </span>
                          )}
                          {!c.subAccountRef && (
                            <button
                              className="abtn abtn-blue" style={{ fontSize: 11, padding: '5px 10px' }}
                              onClick={() => ouvrirAcceptation(c)} disabled={inviting === c.id}
                            >
                              {inviting === c.id ? '⏳...' : '📨 Inviter comme sous-compte'}
                            </button>
                          )}
                        </div>
                        {c.commissionAcceptedAt && (
                          <div style={{ fontSize: 10.5, color: 'var(--green)', marginTop: 4 }}>
                            ✅ Conditions acceptées le {new Date(c.commissionAcceptedAt).toLocaleDateString('fr-FR')} (taux {c.commissionAcceptedRate}%)
                          </div>
                        )}
                        {!c.subAccountRef && (
                          <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                            <input
                              placeholder="Ou coller la référence une fois validée (acc_xxxxxxxxx)"
                              value={refDrafts[c.id] || ''}
                              onChange={e => setRefDrafts(d => ({ ...d, [c.id]: e.target.value }))}
                              style={{ flex: 1, fontSize: 11.5 }}
                            />
                            <button className="abtn abtn-muted" style={{ fontSize: 11, padding: '5px 10px' }} onClick={() => enregistrerRefManuelle(c)}>
                              Enregistrer
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Abonnements à surveiller — détection auto + action manuelle */}
                <div className="dec-section-label" style={{ marginBottom: 4 }}>📅 Abonnements à surveiller</div>
                <p className="tab-desc" style={{ marginTop: -2 }}>
                  Statut calculé automatiquement (essai gratuit, actif, en retard). La coupure réelle de l'accès
                  reste une action manuelle ci-dessous — une automatisation complète nécessiterait une tâche
                  planifiée côté serveur (Firebase Cloud Function), non incluse dans ce projet.
                </p>
                {abonnements.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 20, color: 'var(--muted)', fontSize: 13, background: 'rgba(255,255,255,0.02)', borderRadius: 10, marginBottom: 20 }}>
                    Aucun abonnement actif pour le moment.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
                    {abonnements.map(c => {
                      const st = computeSubscriptionStatus(c, graceDays);
                      return (
                        <div key={c.id} style={{ background: 'rgba(13,27,62,0.5)', border: `1px solid ${st.color}33`, borderRadius: 8, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                          <span style={{ background: st.color + '22', color: st.color, fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 6, whiteSpace: 'nowrap' }}>
                            {st.label}
                          </span>
                          <div style={{ flex: 1, minWidth: 140 }}>
                            <div style={{ fontWeight: 700, fontSize: 13 }}>{c.cnom || c.client}</div>
                            <div style={{ fontSize: 11, color: 'var(--muted)' }}>{c.num} · Échéance : {c.dateProchainPaiement}</div>
                          </div>
                          {st.statut === 'suspendu' ? (
                            <button className="abtn abtn-green" style={{ fontSize: 11, padding: '5px 10px' }} onClick={() => reactiverAbo(c)}>▶️ Réactiver</button>
                          ) : (
                            <>
                              <button className="abtn abtn-blue" style={{ fontSize: 11, padding: '5px 10px' }} onClick={() => renouvelerAbo(c)}>✅ Marquer payé (+30j)</button>
                              <button className="abtn abtn-red" style={{ fontSize: 11, padding: '5px 10px' }} onClick={() => suspendreAbo(c)}>⛔ Suspendre</button>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Gestion des produits */}
                <div className="dec-section-label" style={{ marginBottom: 8 }}>🗂 Catalogue produits</div>
                <button className="abtn abtn-green" style={{ marginBottom: 14 }} onClick={addProduit}>
                  + Ajouter un produit
                </button>
                {(data.produits || []).map(p => (
                  <ProduitEditor
                    key={p.id}
                    p={p}
                    onUpdate={updateProduit}
                    onRemove={removeProduit}
                  />
                ))}
              </div>
            )}
            
            {/* ══ DIGITALISATION ══ */}
{tab === 'digitalisation' && (
  <div>
    <h3>🌐 Digitalisation — Configuration des prix</h3>
    <p style={{color:'var(--muted)',fontSize:'13px',marginBottom:'20px'}}>
      Modifiez les prix d'installation et d'entretien mensuel par secteur et par pack.
      Sauvegardé automatiquement dans Firebase.
    </p>

    {/* Taux de change */}
    <div style={{
      background:'rgba(0,191,255,0.06)', border:'1px solid rgba(0,191,255,0.2)',
      borderRadius:'10px', padding:'16px', marginBottom:'20px'
    }}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'12px',flexWrap:'wrap',gap:'8px'}}>
        <div style={{color:'var(--primary)',fontWeight:700,fontSize:'14px'}}>
          💱 Taux de change en temps réel
        </div>
        <div style={{fontSize:'11px',color:'var(--muted)',background:'rgba(0,204,136,0.1)',border:'1px solid rgba(0,204,136,0.2)',borderRadius:'6px',padding:'4px 10px'}}>
          {data.tauxChange?.auto ? '🟢 Auto — ' : '⚙️ '}
          Source : {data.tauxChange?.source || 'Frankfurter / BCE'}
        </div>
      </div>
      <div className="grid3" style={{gap:'10px',marginBottom:'12px'}}>
        <div style={{background:'rgba(255,255,255,0.04)',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
          <div style={{fontSize:'11px',color:'var(--muted)',marginBottom:'4px'}}>1 EUR =</div>
          <div style={{fontSize:'18px',fontWeight:900,color:'var(--primary)'}}>
            {Math.round(data.tauxChange?.fcfaParEur || 655.957).toLocaleString('fr-FR')}
          </div>
          <div style={{fontSize:'11px',color:'var(--muted)'}}>FCFA (fixe BCE)</div>
        </div>
        <div style={{background:'rgba(255,255,255,0.04)',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
          <div style={{fontSize:'11px',color:'var(--muted)',marginBottom:'4px'}}>1 USD =</div>
          <div style={{fontSize:'18px',fontWeight:900,color:'var(--gold)'}}>
            {Math.round(data.tauxChange?.fcfaParUsd || 600).toLocaleString('fr-FR')}
          </div>
          <div style={{fontSize:'11px',color:'var(--muted)'}}>FCFA (variable)</div>
        </div>
        <div style={{background:'rgba(255,255,255,0.04)',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
          <div style={{fontSize:'11px',color:'var(--muted)',marginBottom:'4px'}}>Dernière mise à jour</div>
          <div style={{fontSize:'13px',fontWeight:700,color:'#00CC88'}}>
            {data.tauxChange?.lastUpdate || '—'}
          </div>
          <div style={{fontSize:'10px',color:'var(--muted)'}}>
            {data.tauxChange?.lastUpdateFull || 'Non disponible'}
          </div>
        </div>
      </div>
      <button className="abtn abtn-blue" style={{fontSize:'12px',padding:'7px 16px'}}
        onClick={() => { localStorage.removeItem('kotos_exchange_rates'); window.location.reload(); }}
      >
        🔄 Forcer la mise à jour maintenant
      </button>
      <p style={{fontSize:'11px',color:'var(--muted)',margin:'8px 0 0'}}>
        ⚡ Mis à jour automatiquement toutes les 24h. EUR/FCFA = 655.957 (fixe Zone CFA). USD/FCFA = variable.
      </p>
    </div>

    {/* Secteurs */}
    {(data.digitalisation?.secteurs || []).map((secteur, si) => (
      <div key={secteur.id} style={{
        background:'var(--cbg)', border:'1px solid var(--border)',
        borderRadius:'12px', padding:'20px', marginBottom:'16px'
      }}>
        <h4 style={{color:'var(--primary)',marginBottom:'16px',fontSize:'16px'}}>
          {secteur.icon} {secteur.name}
        </h4>

        {secteur.packs.map((pack, pi) => (
          <div key={pack.id} style={{
            background:'rgba(255,255,255,0.03)',
            border:`1px solid ${pack.color}33`,
            borderRadius:'10px', padding:'16px', marginBottom:'12px'
          }}>
            {/* Nom pack */}
            <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'14px'}}>
              <span style={{
                background:pack.color, color:'#0A0F1E',
                padding:'3px 12px', borderRadius:'6px', fontWeight:900, fontSize:'13px'
              }}>
                {pack.name}
              </span>
              <span style={{fontSize:'12px',color:'var(--muted)'}}>{pack.desc}</span>
            </div>

            {/* ── INSTALLATION — PAIEMENT UNIQUE ── */}
            <div style={{
              background:'rgba(0,191,255,0.05)',
              border:'1px solid rgba(0,191,255,0.15)',
              borderRadius:'8px', padding:'12px', marginBottom:'10px'
            }}>
              <div style={{color:'var(--primary)',fontWeight:700,fontSize:'12px',marginBottom:'8px'}}>
                💰 Prix d'installation — Paiement unique
              </div>
              <div className="grid3" style={{gap:'10px'}}>
                <div className="fg2">
                  <label>FCFA <span style={{fontSize:'10px',color:'var(--muted)'}}>(unique)</span></label>
                  <input type="number" min={0} value={pack.prixFcfa}
                    onChange={e => {
                      const fcfa = +e.target.value;
                      const taux = data.tauxChange || {};
                      const newDig = JSON.parse(JSON.stringify(data.digitalisation));
                      newDig.secteurs[si].packs[pi].prixFcfa = fcfa;
                      newDig.secteurs[si].packs[pi].prixUsd  = Math.round(fcfa * (taux.usdParFcfa || 0.00162));
                      newDig.secteurs[si].packs[pi].prixEur  = Math.round(fcfa * (taux.eurParFcfa || 1/655.957));
                      updateData({ digitalisation: newDig });
                    }}
                  />
                </div>
                <div className="fg2">
                  <label>💵 USD <span style={{fontSize:'10px',color:'var(--muted)'}}>(auto · unique)</span></label>
                  <input type="number" value={pack.prixUsd}
                    style={{color:'var(--gold)',opacity:0.8}} readOnly
                  />
                </div>
                <div className="fg2">
                  <label>💶 EUR <span style={{fontSize:'10px',color:'var(--muted)'}}>(auto · unique)</span></label>
                  <input type="number" value={pack.prixEur}
                    style={{color:'var(--primary)',opacity:0.8}} readOnly
                  />
                </div>
              </div>
            </div>

            {/* ── ENTRETIEN MENSUEL — ABONNEMENT ── */}
            <div style={{
              background:'rgba(0,204,136,0.05)',
              border:'1px solid rgba(0,204,136,0.2)',
              borderRadius:'8px', padding:'12px'
            }}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'10px'}}>
                <div style={{color:'#00CC88',fontWeight:700,fontSize:'12px'}}>
                  🔧 Entretien mensuel — Abonnement récurrent
                </div>
                <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                  <span style={{fontSize:'11px',color:'var(--muted)'}}>
                    {pack.entretienActif ? 'Activé ✅' : 'Désactivé ❌'}
                  </span>
                  <div
                    onClick={() => {
                      const newDig = JSON.parse(JSON.stringify(data.digitalisation));
                      newDig.secteurs[si].packs[pi].entretienActif = !pack.entretienActif;
                      updateData({ digitalisation: newDig });
                    }}
                    style={{
                      width:'40px', height:'22px', borderRadius:'11px',
                      background: pack.entretienActif ? '#00CC88' : 'rgba(255,255,255,0.15)',
                      position:'relative', cursor:'pointer', transition:'background .2s', flexShrink:0,
                    }}
                  >
                    <div style={{
                      position:'absolute', top:'3px',
                      left: pack.entretienActif ? '20px' : '3px',
                      width:'16px', height:'16px', borderRadius:'50%',
                      background:'white', transition:'left .2s'
                    }}/>
                  </div>
                </div>
              </div>

              {pack.entretienActif && (
                <div className="grid3" style={{gap:'10px'}}>
                  <div className="fg2">
                    <label>FCFA <span style={{fontSize:'10px',color:'var(--muted)'}}>/mois</span></label>
                    <input type="number" min={0} value={pack.entretienFcfa}
                      onChange={e => {
                        const fcfa = +e.target.value;
                        const taux = data.tauxChange || {};
                        const newDig = JSON.parse(JSON.stringify(data.digitalisation));
                        newDig.secteurs[si].packs[pi].entretienFcfa = fcfa;
                        newDig.secteurs[si].packs[pi].entretienUsd  = Math.round(fcfa * (taux.usdParFcfa || 0.00162));
                        newDig.secteurs[si].packs[pi].entretienEur  = Math.round(fcfa * (taux.eurParFcfa || 1/655.957));
                        updateData({ digitalisation: newDig });
                      }}
                    />
                  </div>
                  <div className="fg2">
                    <label>💵 USD <span style={{fontSize:'10px',color:'var(--muted)'}}>/mois (auto)</span></label>
                    <input type="number" value={pack.entretienUsd}
                      style={{color:'var(--gold)',opacity:0.8}} readOnly
                    />
                  </div>
                  <div className="fg2">
                    <label>💶 EUR <span style={{fontSize:'10px',color:'var(--muted)'}}>/mois (auto)</span></label>
                    <input type="number" value={pack.entretienEur}
                      style={{color:'var(--primary)',opacity:0.8}} readOnly
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    ))}

    {/* Bouton sauvegarder */}
    <button
      className="abtn abtn-green"
      style={{width:'100%', marginTop:'8px', padding:'12px'}}
      onClick={() => {
        updateData({ digitalisation: data.digitalisation });
        showToast('Prix de digitalisation sauvegardés ✓', 'ok');
      }}
    >
      💾 Sauvegarder tous les prix
    </button>
  </div>
)}
            {/* ══ FINANCES ══ */}
            {tab === 'finances' && (
              <div>
                <h3>📊 Finances</h3>
                <p className="tab-desc">Encaissements, dépenses, bénéfice et classement des services — tous types de transactions confondus (factures, devis, commandes boutique, paiements sur devis).</p>

                {/* KPIs principaux */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 10 }}>
                  {[
                    { label: "Encaissé aujourd'hui", value: fmt(encJour), color: '#00CC88', icon: '💵' },
                    { label: 'Encaissé ce mois', value: fmt(encMois), color: '#00BFFF', icon: '📅' },
                    { label: 'Encaissé cette année', value: fmt(encAnnee), color: '#D4A017', icon: '📈' },
                  ].map((s, i) => (
                    <div key={i} style={{ background: 'rgba(13,27,62,0.6)', border: `1px solid ${s.color}33`, borderRadius: 10, padding: 14, textAlign: 'center' }}>
                      <div style={{ fontSize: 20, marginBottom: 4 }}>{s.icon}</div>
                      <div style={{ fontSize: 16, fontWeight: 900, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>{s.label}</div>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 22 }}>
                  {[
                    { label: 'Dépenses ce mois', value: fmt(depMois), color: '#FF4060', icon: '💸' },
                    { label: 'Bénéfice ce mois', value: fmt(beneficeMois), color: beneficeMois >= 0 ? '#00CC88' : '#FF4060', icon: '🧮' },
                    { label: 'Bénéfice cette année', value: fmt(beneficeAnnee), color: beneficeAnnee >= 0 ? '#00CC88' : '#FF4060', icon: '🏆' },
                  ].map((s, i) => (
                    <div key={i} style={{ background: 'rgba(13,27,62,0.6)', border: `1px solid ${s.color}33`, borderRadius: 10, padding: 14, textAlign: 'center' }}>
                      <div style={{ fontSize: 20, marginBottom: 4 }}>{s.icon}</div>
                      <div style={{ fontSize: 16, fontWeight: 900, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>{s.label}</div>
                    </div>
                  ))}
                </div>
                <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: -10, marginBottom: 20 }}>{nbEncMois} transaction(s) payée(s) ce mois-ci.</p>

                {/* Applications sur mesure commandées */}
                <div className="dec-section-label">🛠 Applications sur mesure commandées ({surMesure.length})</div>
                {surMesure.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 16, color: 'var(--muted)', fontSize: 13, background: 'rgba(255,255,255,0.02)', borderRadius: 10, marginBottom: 22 }}>
                    Aucune demande d'application sur mesure pour le moment.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 22 }}>
                    {surMesure.slice(0, 10).map(t => (
                      <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(13,27,62,0.5)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '8px 14px', fontSize: 12.5 }}>
                        <span>{t.cnom || t.client} — {t.num}</span>
                        <span style={{ color: t.statut === 'payé' ? 'var(--green)' : 'var(--muted)', fontWeight: 700 }}>
                          {fmt(t.total)} {t.statut === 'payé' ? '✅' : '⏳'}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Répartition par grande rubrique — d'où vient la vraie rentabilité */}
                <div className="dec-section-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>🧭 Répartition des rentrées par rubrique</span>
                  <span style={{ display: 'flex', gap: 4 }}>
                    <button
                      className={vueRepartition === 'mois' ? 'abtn abtn-blue' : 'abtn abtn-muted'}
                      style={{ fontSize: 10, padding: '4px 10px' }}
                      onClick={() => setVueRepartition('mois')}
                    >Ce mois</button>
                    <button
                      className={vueRepartition === 'annee' ? 'abtn abtn-blue' : 'abtn abtn-muted'}
                      style={{ fontSize: 10, padding: '4px 10px' }}
                      onClick={() => setVueRepartition('annee')}
                    >Cette année</button>
                  </span>
                </div>
                <p className="tab-desc" style={{ marginTop: -2 }}>
                  Chaque encaissement est classé automatiquement dans une seule rubrique, pour voir d'un
                  coup d'œil d'où vient réellement la rentabilité.
                </p>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 14 }}>
                  {[
                    { key: 'abonnement', icon: '🔁', color: '#00CC88' },
                    { key: 'sur_mesure', icon: '🛠', color: '#00BFFF' },
                    { key: 'entretien',  icon: '🧰', color: '#D4A017' },
                    { key: 'marketplace',icon: '🔗', color: '#FF9F1C' },
                    { key: 'digitalisation', icon: '🌐', color: '#9B59B6' },
                  ].map(({ key, icon, color }) => {
                    const b = repartitionActive.buckets[key];
                    // Ajouter cette protection
                    if (!b || b.total === undefined) return null;
                    return (
                     <div key={key} style={{ background: 'rgba(13,27,62,0.6)', border: `1px solid ${color}33`, borderRadius: 10, padding: 12, textAlign: 'center' }}>
                       <div style={{ fontSize: 18, marginBottom: 4 }}>{icon}</div>
                       <div style={{ fontSize: 14, fontWeight: 900, color }}>{fmt(b.total)}</div>
                       <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 4 }}>{b.label}</div>
                       <div style={{ fontSize: 9.5, color: 'var(--muted)' }}>{b.count} transaction(s)</div>
                       </div>
                     );
                  })}
                </div>

                <div style={{ background: 'rgba(13,27,62,0.5)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 14, marginBottom: 22 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontWeight: 700, fontSize: 12.5 }}>📦 {repartitionActive.buckets.autres.label}</span>
                    <strong style={{ color: 'var(--gold)' }}>{fmt(repartitionActive.buckets.autres.total)}</strong>
                  </div>
                  {repartitionActive.buckets.autres.detailList.length === 0 ? (
                    <p style={{ fontSize: 11.5, color: 'var(--muted)' }}>Aucune rentrée hors abonnement/sur-mesure/entretien/marketplace sur cette période.</p>
                  ) : (
                    repartitionActive.buckets.autres.detailList.slice(0, 8).map((d, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, padding: '4px 0', color: 'var(--muted)' }}>
                        <span>{d.libelle}</span><span>{fmt(d.montant)}</span>
                      </div>
                    ))
                  )}
                  <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 8, fontStyle: 'italic' }}>
                    Regroupe notamment Panneaux Solaires, Immobilier, Forage, Photocopie/Graphisme — classés
                    ici selon le libellé exact saisi sur chaque facture/devis.
                  </div>
                </div>

                <div style={{ textAlign: 'right', fontSize: 12, color: 'var(--muted)', marginTop: -12, marginBottom: 22 }}>
                  Total toutes rubriques ({vueRepartition === 'mois' ? 'ce mois' : 'cette année'}) :
                  <strong style={{ color: 'var(--text)', marginLeft: 6 }}>{fmt(repartitionActive.totalGeneral)}</strong>
                </div>

                {/* Commissions marketplace en attente de confirmation */}
                {(() => {
                  const commissionsEnAttente = (data.transactions || []).filter(t => t.type === 'commission_marketplace' && t.statut !== 'payé');
                  if (commissionsEnAttente.length === 0) return null;
                  return (
                    <>
                      <div className="dec-section-label">⏳ Commissions marketplace en attente de confirmation</div>
                      <p className="tab-desc" style={{ marginTop: -2 }}>
                        Ces commissions ne sont pas encore comptabilisées dans les totaux ci-dessus (paiement du
                        client final pas encore confirmé côté FedaPay — pas de webhook automatique pour l'instant).
                        Confirmez-les manuellement une fois le paiement vérifié.
                      </p>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 22 }}>
                        {commissionsEnAttente.map(t => (
                          <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(255,159,28,0.06)', border: '1px solid rgba(255,159,28,0.25)', borderRadius: 8, padding: '8px 14px', fontSize: 12.5 }}>
                            <span>{t.cnom || t.client} — {fmt(t.total)} ({t.commissionPct}%)</span>
                            <button className="abtn abtn-green" style={{ fontSize: 10, padding: '4px 10px' }} onClick={() => updateTransaction(t.id, { statut: 'payé' })}>
                              ✅ Marquer encaissé
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  );
                })()}

                {/* Classement des services */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 22 }}>
                  <div>
                    <div className="dec-section-label">🏅 Services les plus rentables (ce mois)</div>
                    {classementMois.length === 0 ? (
                      <p style={{ fontSize: 12, color: 'var(--muted)' }}>Aucune donnée ce mois.</p>
                    ) : classementMois.slice(0, 6).map((s, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                        <span>{i + 1}. {s.categorie}</span>
                        <strong style={{ color: 'var(--gold)' }}>{fmt(s.montant)}</strong>
                      </div>
                    ))}
                  </div>
                  <div>
                    <div className="dec-section-label">🏆 Services les plus rentables (cette année)</div>
                    {classementAnnee.length === 0 ? (
                      <p style={{ fontSize: 12, color: 'var(--muted)' }}>Aucune donnée cette année.</p>
                    ) : classementAnnee.slice(0, 6).map((s, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                        <span>{i + 1}. {s.categorie}</span>
                        <strong style={{ color: 'var(--gold)' }}>{fmt(s.montant)}</strong>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Point journalier du mois en cours */}
                <div className="dec-section-label">📆 Point journalier (mois en cours)</div>
                {journalierMois.length === 0 ? (
                  <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 22 }}>Aucun encaissement ce mois.</p>
                ) : (
                  <div style={{ maxHeight: 180, overflowY: 'auto', marginBottom: 22 }}>
                    {journalierMois.map(j => (
                      <div key={j.date} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                        <span style={{ color: 'var(--muted)' }}>{new Date(j.date).toLocaleDateString('fr-FR')}</span>
                        <strong>{fmt(j.montant)}</strong>
                      </div>
                    ))}
                  </div>
                )}

                {/* Dépenses */}
                <div className="dec-section-label">💸 Dépenses (personnel &amp; autres)</div>
                <div style={{ display: 'flex', gap: 12, marginBottom: 12, fontSize: 12 }}>
                  <span>Personnel ce mois : <strong style={{ color: 'var(--red)' }}>{fmt(depParCatMois.personnel)}</strong></span>
                  <span>Autres ce mois : <strong style={{ color: 'var(--red)' }}>{fmt(depParCatMois.autre)}</strong></span>
                  <span>Total année : <strong style={{ color: 'var(--red)' }}>{fmt(depAnnee)}</strong></span>
                </div>
                <div className="grid3" style={{ marginBottom: 8 }}>
                  <div className="fg2">
                    <label>Catégorie</label>
                    <select value={depForm.categorie} onChange={e => setDepForm(f => ({ ...f, categorie: e.target.value }))}>
                      <option value="personnel">👤 Personnel (salaires, primes...)</option>
                      <option value="autre">📦 Autre dépense (loyer, matériel...)</option>
                    </select>
                  </div>
                  <div className="fg2"><label>Libellé</label>
                    <input value={depForm.libelle} onChange={e => setDepForm(f => ({ ...f, libelle: e.target.value }))} placeholder="Ex: Salaire développeur" />
                  </div>
                  <div className="fg2"><label>Montant (FCFA)</label>
                    <input type="number" value={depForm.montant} onChange={e => setDepForm(f => ({ ...f, montant: e.target.value }))} placeholder="Ex: 150000" />
                  </div>
                </div>
                <div className="fg2" style={{ maxWidth: 200 }}>
                  <label>Date</label>
                  <input type="date" value={depForm.date} onChange={e => setDepForm(f => ({ ...f, date: e.target.value }))} />
                </div>
                <button className="abtn abtn-blue" style={{ marginBottom: 16 }} onClick={ajouterDepense}>+ Ajouter la dépense</button>

                {(data.depenses || []).length === 0 ? (
                  <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 22 }}>Aucune dépense enregistrée.</p>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 22 }}>
                    {(data.depenses || []).slice(0, 15).map(d => (
                      <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(13,27,62,0.5)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '8px 14px', fontSize: 12.5 }}>
                        <span>{d.categorie === 'personnel' ? '👤' : '📦'} {d.libelle} — {new Date(d.date).toLocaleDateString('fr-FR')}</span>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <strong style={{ color: 'var(--red)' }}>{fmt(d.montant)}</strong>
                          <button className="abtn abtn-red" style={{ fontSize: 10, padding: '3px 7px' }} onClick={() => supprimerDepense(d.id)}>🗑</button>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ══ VISITEURS ══ */}
            {tab === 'visiteurs' && (
  <div>
    <h3>👥 Visiteurs & Analytics</h3>

    {/* ── Filtres période + type ── */}
<div style={{display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'20px', alignItems:'center'}}>
  
  {/* Période */}
  <div style={{display:'flex', gap:'6px', background:'var(--cbg)', borderRadius:'8px', padding:'4px'}}>
    {[
      { key:'jour',  label:"Aujourd'hui" },
      { key:'mois',  label:'Ce mois' },
      { key:'annee', label:'Cette année' },
      { key:'tout',  label:'Tout' },
    ].map(p => (
      <button key={p.key}
        onClick={() => setFiltreVisitesPeriode(p.key)}
        style={{
          padding:'6px 14px', borderRadius:'6px', border:'none',
          fontFamily:'var(--font-body)', fontSize:'12px', fontWeight:700,
          cursor:'pointer', transition:'all .2s',
          background: filtreVisitesPeriode === p.key ? 'var(--primary)' : 'transparent',
          color:      filtreVisitesPeriode === p.key ? 'var(--dark)'    : 'var(--muted)',
        }}
      >
        {p.label}
      </button>
    ))}
  </div>

  {/* Type */}
  <div style={{display:'flex', gap:'6px', background:'var(--cbg)', borderRadius:'8px', padding:'4px'}}>
    {[
      { key:'clients', label:'🌍 Clients',  color:'var(--primary)' },
      { key:'equipe',  label:'🔧 Équipe',   color:'var(--gold)'    },
      { key:'tous',    label:'📊 Tous',     color:'#00CC88'        },
    ].map(t => (
      <button key={t.key}
        onClick={() => setFiltreVisitesType(t.key)}
        style={{
          padding:'6px 14px', borderRadius:'6px', border:'none',
          fontFamily:'var(--font-body)', fontSize:'12px', fontWeight:700,
          cursor:'pointer', transition:'all .2s',
          background: filtreVisitesType === t.key ? t.color          : 'transparent',
          color:      filtreVisitesType === t.key ? 'var(--dark)'    : 'var(--muted)',
        }}
      >
        {t.label}
      </button>
    ))}
  </div>

  {/* Compteur */}
  <span style={{fontSize:'12px', color:'var(--muted)', marginLeft:'auto'}}>
    {filtreVisitesType === 'clients' ? clientsFiltres.length :
     filtreVisitesType === 'equipe'  ? equipeFiltree.length  :
     clientsFiltres.length + equipeFiltree.length} visite(s)
  </span>
</div>

    {/* ── Stats en 2 colonnes : Clients vs Équipe ── */}
    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px', marginBottom:'24px'}}>

      {/* Clients */}
      <div style={{
        background:'rgba(0,191,255,0.06)', border:'1px solid rgba(0,191,255,0.25)',
        borderRadius:'12px', padding:'16px'
      }}>
        <div style={{color:'var(--primary)',fontWeight:800,fontSize:'14px',marginBottom:'12px',display:'flex',alignItems:'center',gap:'8px'}}>
          🌍 Visiteurs Clients
        </div>
        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px'}}>
          {[
            { label: "Aujourd'hui", val: visitesJour },
            { label: 'Ce mois',     val: visitesMois },
            { label: 'Total',       val: visitesTotal },
          ].map(s => (
            <div key={s.label} style={{textAlign:'center', background:'rgba(0,0,0,0.2)', borderRadius:'8px', padding:'10px'}}>
              <div style={{fontSize:'22px', fontWeight:900, color:'var(--primary)'}}>{s.val}</div>
              <div style={{fontSize:'10px', color:'var(--muted)', marginTop:'4px'}}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Équipe interne */}
      <div style={{
        background:'rgba(212,160,23,0.06)', border:'1px solid rgba(212,160,23,0.25)',
        borderRadius:'12px', padding:'16px'
      }}>
        <div style={{color:'var(--gold)',fontWeight:800,fontSize:'14px',marginBottom:'12px',display:'flex',alignItems:'center',gap:'8px'}}>
          🔧 Équipe Interne
          <span style={{fontSize:'11px',color:'var(--muted)',fontWeight:400}}>
            (Admin & membres)
          </span>
        </div>
        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px'}}>
          {[
            { label: "Aujourd'hui", val: equipeJour },
            { label: 'Ce mois',     val: equipeMois },
            { label: 'Total',       val: equipeTotal },
          ].map(s => (
            <div key={s.label} style={{textAlign:'center', background:'rgba(0,0,0,0.2)', borderRadius:'8px', padding:'10px'}}>
              <div style={{fontSize:'22px', fontWeight:900, color:'var(--gold)'}}>{s.val}</div>
              <div style={{fontSize:'10px', color:'var(--muted)', marginTop:'4px'}}>{s.label}</div>
            </div>
          ))}
        </div>
        {/* Membres actifs */}
        {Object.keys(equipeParMembre).length > 0 && (
          <div style={{marginTop:'10px', borderTop:'1px solid rgba(212,160,23,0.15)', paddingTop:'10px'}}>
            {Object.entries(equipeParMembre).map(([nom, count]) => (
              <div key={nom} style={{display:'flex',justifyContent:'space-between',fontSize:'12px',color:'var(--muted)',marginBottom:'4px'}}>
                <span>👤 {nom}</span>
                <span style={{color:'var(--gold)',fontWeight:700}}>{count} visite(s)</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

    {/* ── Répartition par pays (clients uniquement) ── */}
    {paysTop.length > 0 && (
      <div style={{marginBottom:'20px'}}>
        <div style={{color:'var(--primary)',fontWeight:700,fontSize:'13px',marginBottom:'10px',display:'flex',alignItems:'center',gap:'6px'}}>
          🌐 RÉPARTITION PAR PAYS — Clients uniquement
        </div>
        <div style={{display:'flex', flexDirection:'column', gap:'6px'}}>
          {paysTop.map(([pays, count]) => {
            const pct = visitesTotal > 0 ? Math.round(count / visitesTotal * 100) : 0;
            return (
              <div key={pays} style={{display:'flex', alignItems:'center', gap:'10px'}}>
                <span style={{fontSize:'12px', color:'var(--text)', minWidth:'140px'}}>{pays}</span>
                <div style={{flex:1, background:'rgba(255,255,255,0.06)', borderRadius:'4px', height:'8px', overflow:'hidden'}}>
                  <div style={{width:`${pct}%`, height:'100%', background:'var(--primary)', borderRadius:'4px', transition:'width .5s'}}/>
                </div>
                <span style={{fontSize:'12px', color:'var(--primary)', fontWeight:700, minWidth:'30px', textAlign:'right'}}>{count}</span>
                <span style={{fontSize:'11px', color:'var(--muted)', minWidth:'35px'}}>{pct}%</span>
              </div>
            );
          })}
        </div>
      </div>
    )}

    {/* ── Dernières visites clients ── */}
    <div style={{marginBottom:'20px'}}>
      <div style={{color:'var(--primary)',fontWeight:700,fontSize:'13px',marginBottom:'10px'}}>
        🌍 DERNIÈRES VISITES CLIENTS
      </div>
      {clientsFiltres.length === 0 ? (
        <div style={{color:'var(--muted)',fontSize:'13px',textAlign:'center',padding:'20px'}}>
          Aucune visite client enregistrée
        </div>
      ) : (
        [...clientsFiltres].reverse().slice(0, 15).map((v, i) => (
          <div key={i} style={{
            background:'rgba(13,27,62,0.6)', borderRadius:'8px',
            padding:'10px 14px', marginBottom:'6px', fontSize:'12px'
          }}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:'4px'}}>
              <div>
                <span style={{color:'var(--primary)', fontWeight:700}}>
                  {v.ville ? `${v.ville}, ` : ''}{v.pays || 'Inconnu'}
                </span>
                {v.isp && <span style={{color:'var(--muted)'}}> · {v.isp}</span>}
              </div>
              <span style={{color:'var(--muted)', fontSize:'11px', whiteSpace:'nowrap'}}>
                {v.fullDate || v.dateStr || ''}
              </span>
            </div>
            {(v.device || v.browser || v.entree) && (
              <div style={{color:'var(--muted)', marginTop:'3px'}}>
                {[v.device, v.browser, v.entree ? `Entrée : ${v.entree}` : '', v.referrer ? `Venu de : ${v.referrer}` : ''].filter(Boolean).join(' · ')}
              </div>
            )}
          </div>
        ))
      )}
    </div>

    {/* ── Dernières visites équipe ── */}
    <div>
      <div style={{color:'var(--gold)',fontWeight:700,fontSize:'13px',marginBottom:'10px'}}>
        🔧 DERNIÈRES VISITES ÉQUIPE INTERNE
      </div>
      {equipeFiltree.length === 0 ? (
        <div style={{color:'var(--muted)',fontSize:'13px',textAlign:'center',padding:'20px'}}>
          Aucune visite interne enregistrée
        </div>
      ) : (
        [...equipeFiltree].reverse().slice(0, 10).map((v, i) => (
          <div key={i} style={{
            background:'rgba(212,160,23,0.05)',
            border:'1px solid rgba(212,160,23,0.15)',
            borderRadius:'8px', padding:'10px 14px',
            marginBottom:'6px', fontSize:'12px'
          }}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'4px'}}>
              <div>
                <span style={{color:'var(--gold)', fontWeight:700}}>
                  👤 {v.membre || 'Membre'}
                </span>
                <span style={{color:'var(--muted)'}}> · {v.role || v.type || ''}</span>
              </div>
              <span style={{color:'var(--muted)', fontSize:'11px'}}>
                {v.fullDate || v.dateStr || ''}
              </span>
            </div>
            {(v.browser || v.entree) && (
              <div style={{color:'var(--muted)', marginTop:'3px'}}>
                {[v.browser, v.entree ? `Page : ${v.entree}` : ''].filter(Boolean).join(' · ')}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  </div>
)}

            {/* ══ OUVRIERS ══ */}
            {tab === 'workers' && (
              <div>
                <h3>👷 Ouvriers / Managers</h3>
                <p className="tab-desc">Chaque ouvrier accède au facturier et devis avec son code.</p>
                <div className="add-worker-box">
                  <h4>+ Ajouter un ouvrier</h4>
                  <div className="grid2">
                    <div className="fg2"><label>Nom complet</label><input value={nwName} onChange={e => setNwName(e.target.value)} placeholder="Ex: Jean Kouassi" /></div>
                    <div className="fg2">
                      <label>Rôle</label>
                      <select value={nwRole} onChange={e => setNwRole(e.target.value)}>
                        <option value="ouvrier">Ouvrier</option>
                        <option value="manager">Manager</option>
                      </select>
                    </div>
                  </div>
                  <div className="grid2">
                    <div className="fg2"><label>Code d'accès</label><input value={nwPwd} onChange={e => setNwPwd(e.target.value)} placeholder="Ex: 1234" /></div>
                    <div className="fg2"><label>Email (optionnel)</label><input value={nwEmail} onChange={e => setNwEmail(e.target.value)} placeholder="email@example.com" /></div>
                  </div>
                  <button className="abtn abtn-green" onClick={addWorker}>+ Ajouter</button>
                </div>
                <div className="workers-grid">
                  {data.workers.map(w => (
                    <div key={w.id} className="worker-card">
                      <div className="wc-name">{w.name}</div>
                      <div className="wc-role">{w.role} {w.role === 'manager' ? '👔' : '🔧'}</div>
                      <div className="wc-code">Code : {'•'.repeat(w.pwd.length)} ({w.pwd.length} car.)</div>
                      {w.email && <div className="wc-email">📧 {w.email}</div>}
                      <div className="wc-actions">
                        <button className="abtn abtn-blue" style={{ fontSize: 10, padding: '5px 10px' }} onClick={() => editWorkerPwd(w.id, w.name)}>✏ Modifier code</button>
                        <button className="abtn abtn-red"  style={{ fontSize: 10, padding: '5px 10px' }} onClick={() => removeWorker(w.id)}>✕ Suppr.</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ══ CONTACT ══ */}
            {tab === 'contact' && (
              <div>
                <h3>📞 Contact &amp; Infos légales</h3>
                {[
                  ['tel', 'Téléphone/WhatsApp'], ['email', 'Email principal'],
                  ['email2', 'Email secondaire'],
                  ['address', 'Adresse'], ['hours', 'Horaires'],
                  ['rccm', 'N° RCCM'], ['rccmVille', 'Délivré à'],
                  ['raison', 'Raison sociale'], ['ifu', 'N° IFU'],
                ].map(([k, lbl]) => (
                  <div key={k} className="fg2">
                    <label>{lbl}</label>
                    <input value={contact[k] || ''} onChange={e => setContact(c => ({ ...c, [k]: e.target.value }))} />
                  </div>
                ))}
                <button className="abtn abtn-blue" onClick={() => { updateData({ contact }); showToast('Contact mis à jour'); }}>✓ Appliquer</button>
              </div>
            )}

            {/* ══ PAIEMENT ══ */}
            {tab === 'paiement' && (
              <div>
                <h3>💳 Coordonnées de Paiement</h3>
                <p className="tab-desc">Ces informations apparaissent dans les factures, devis et dans le chatbot KotoBot.</p>
                <div className="pay-section-title">📱 MOBILE MONEY — Numéros de réception</div>
                <div className="pay-operator-grid">
                  <div className="pay-op-card pay-op-mtn">
                    <div className="pay-op-logo">🟡 MTN MoMo</div>
                    <div className="pay-op-hint">Préfixes 96xx, 97xx, 67xx, 62xx · USSD *880#</div>
                    <input className="pay-op-input" value={paiement.mtn || ''} onChange={e => setPaiement(p => ({ ...p, mtn: e.target.value }))} placeholder="+229 97 XX XX XX" />
                  </div>
                  <div className="pay-op-card pay-op-moov">
                    <div className="pay-op-logo">🔵 Moov Money</div>
                    <div className="pay-op-hint">Préfixes 90xx–95xx, 61xx, 64xx · USSD *555#</div>
                    <input className="pay-op-input" value={paiement.moov || ''} onChange={e => setPaiement(p => ({ ...p, moov: e.target.value }))} placeholder="+229 90 XX XX XX" />
                  </div>
                  <div className="pay-op-card pay-op-celtis">
                    <div className="pay-op-logo">🟢 Celtis Cash</div>
                    <div className="pay-op-hint">Préfixes 98xx, 99xx, 66xx · USSD *144#</div>
                    <input className="pay-op-input" value={paiement.celtis || ''} onChange={e => setPaiement(p => ({ ...p, celtis: e.target.value }))} placeholder="+229 98 XX XX XX" />
                  </div>
                </div>
                <div style={{ marginTop: 20 }}>
                  <div className="pay-section-title">🏦 VIREMENT BANCAIRE</div>
                  <div className="fg2">
                    <label>Coordonnées complètes (banque, IBAN/RIB, titulaire…)</label>
                    <textarea rows={4} value={paiement.bank || ''} onChange={e => setPaiement(p => ({ ...p, bank: e.target.value }))}
                      placeholder={`Ex:\nECOBANK BÉNIN\nTitulaire : JEHOVA-JIRE MULTI-SERVICES\nCompte : XX XXXX XXXX XXXX\nCode BIC/SWIFT : ECOCBJBJ`} />
                  </div>
                </div>
                <div className="fg2">
                  <label>💵 Autres modes (espèces, chèque…)</label>
                  <input value={paiement.other || ''} onChange={e => setPaiement(p => ({ ...p, other: e.target.value }))} placeholder="Ex: Espèces acceptées en agence" />
                </div>
                <div className="pay-preview">
                  <div className="pay-preview-title">👁 Aperçu</div>
                  <div className="pay-preview-body">
                    {paiement.mtn    && <div>🟡 MTN MoMo : <strong>{paiement.mtn}</strong></div>}
                    {paiement.moov   && <div>🔵 Moov Money : <strong>{paiement.moov}</strong></div>}
                    {paiement.celtis && <div>🟢 Celtis Cash : <strong>{paiement.celtis}</strong></div>}
                    {!paiement.mtn && !paiement.moov && !paiement.celtis && <div style={{ color: 'var(--muted)' }}>Aucun numéro renseigné</div>}
                    {paiement.bank && !paiement.bank.startsWith('Non rens') && <div style={{ marginTop: 8 }}>🏦 {paiement.bank.split('\n')[0]}</div>}
                  </div>
                </div>
                <button className="abtn abtn-blue" style={{ marginTop: 14 }} onClick={() => { updateData({ paiement }); showToast('Paiement mis à jour !'); }}>
                  ✓ Enregistrer les coordonnées
                </button>
              </div>
            )}

            {/* ══ PHOTOS ENTREPRISE ══ */}
            {tab === 'photos_ent' && (
              <div>
                <h3>📸 Photos de l'Entreprise</h3>
                <p className="tab-desc">Ces photos défilent automatiquement sur le site dans la section galerie entreprise.</p>
                <div className="grid2">
                  <div className="fg2">
                    <label>Catégorie</label>
                    <select value={peCat} onChange={e => setPeCat(e.target.value)}>
                      {['Équipe', 'Locaux', 'Réalisations', 'Événements', 'Formation', 'Autre'].map(c => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                  <div className="fg2">
                    <label>Légende (optionnel)</label>
                    <input value={peCaption} onChange={e => setPeCaption(e.target.value)} placeholder="Décrivez la photo…" />
                  </div>
                </div>
                <button className="abtn abtn-blue" style={{ marginTop: 8 }} onClick={() => document.getElementById('pe-upload').click()}>
                  📷 Ajouter des photos
                </button>
                <input type="file" id="pe-upload" accept="image/*" multiple style={{ display: 'none' }} onChange={addPhotoEntreprise} />
                <div className="photos-grid" style={{ marginTop: 14 }}>
                  {(data.photosEntreprise || []).length === 0 && (
                    <p style={{ fontSize: 12, color: 'var(--muted)' }}>Aucune photo ajoutée.</p>
                  )}
                  {(data.photosEntreprise || []).map((ph, i) => (
                    <div key={ph.id} className="photo-thumb">
                      <img src={ph.data} alt={ph.caption || ''} />
                      <div className="pt-overlay">
                        {ph.caption && <div className="pt-caption">{ph.caption}</div>}
                        {ph.categorie && <div className="pt-cat">{ph.categorie}</div>}
                        <div className="pt-actions">
                          <button onClick={() => movePEnt(ph.id, -1)} disabled={i === 0}>↑</button>
                          <button onClick={() => movePEnt(ph.id, +1)} disabled={i === (data.photosEntreprise.length - 1)}>↓</button>
                          <button onClick={() => removePhotoEnt(ph.id)} className="pt-del">✕</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ══ PHOTOS DOMAINES ══ */}
            {tab === 'photos_dom' && (
              <div>
                <h3>🖼 Photos par Domaine</h3>
                <p className="tab-desc">Ces photos s'affichent en carousel dans la carte du domaine correspondant.</p>
                <div className="grid2">
                  <div className="fg2">
                    <label>Domaine cible</label>
                    <select value={pdDomaine} onChange={e => setPdDomaine(+e.target.value)}>
                      {data.domaines.map(d => <option key={d.id} value={d.id}>{d.icon} {d.name}</option>)}
                    </select>
                  </div>
                  <div className="fg2">
                    <label>Légende (optionnel)</label>
                    <input value={pdCaption} onChange={e => setPdCaption(e.target.value)} placeholder="Légende de la photo…" />
                  </div>
                </div>
                <button className="abtn abtn-blue" style={{ marginTop: 8 }} onClick={() => document.getElementById('pd-upload').click()}>
                  📷 Ajouter des photos
                </button>
                <input type="file" id="pd-upload" accept="image/*" multiple style={{ display: 'none' }} onChange={addPhotoDomaine} />
                <div style={{ marginTop: 16 }}>
                  {data.domaines.map(d => {
                    const imgs = d.images || [];
                    return (
                      <div key={d.id} className="dom-photo-group">
                        <div className="dpg-head">{d.icon} {d.name} — {imgs.length} photo(s)</div>
                        <div className="photos-grid">
                          {imgs.length === 0 && <p style={{ fontSize: 12, color: 'var(--muted)', padding: '6px 0' }}>Aucune photo.</p>}
                          {imgs.map(ph => (
                            <div key={ph.id || ph} className="photo-thumb">
                              <img src={ph.data || ph} alt={ph.caption || ''} />
                              <div className="pt-overlay">
                                {ph.caption && <div className="pt-caption">{ph.caption}</div>}
                                <div className="pt-actions">
                                  <button onClick={() => removePhotoDom(d.id, ph.id)} className="pt-del">✕</button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* ══ MOT DE PASSE ══ */}
            {tab === 'pwd' && (
              <div>
                <h3>🔐 Code Administrateur</h3>
                <div className="fg2"><label>Code actuel</label><input type="password" value={pwdCur} onChange={e => setPwdCur(e.target.value)} placeholder="Code actuel" /></div>
                <div className="fg2"><label>Nouveau code</label><input type="password" value={pwdNew} onChange={e => setPwdNew(e.target.value)} placeholder="Min. 4 caractères" /></div>
                <div className="fg2"><label>Confirmer</label><input type="password" value={pwdCf} onChange={e => setPwdCf(e.target.value)} placeholder="Confirmer" /></div>
                {pwdMsg.txt && <p style={{ fontSize: 12, color: pwdMsg.ok ? 'var(--green)' : 'var(--red)', marginBottom: 10 }}>{pwdMsg.txt}</p>}
                <button className="abtn abtn-blue" onClick={changePwd}>🔐 Modifier le code admin</button>
                <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 14 }}>
                  Pour modifier le code d'un ouvrier, allez dans <strong>👷 Ouvriers</strong>.
                </p>
              </div>
            )}

            {/* ══ EXPORT / IMPORT ══ */}
            {tab === 'export' && (
              <div>
                <h3>💾 Export / Import des données</h3>
                <p className="tab-desc">Sauvegardez toutes vos données ou restaurez depuis un fichier JSON.</p>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 14 }}>
                  <button className="abtn abtn-gold" onClick={exportData}>💾 Exporter JSON</button>
                  <button className="abtn abtn-blue" onClick={() => document.getElementById('imp-file').click()}>📂 Importer JSON</button>
                  <input type="file" id="imp-file" accept=".json" style={{ display: 'none' }} onChange={importData} />
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>

    {/* ══ Modal d'acceptation horodatée des conditions de commission ══ */}
    {acceptModalFor && (
      <div className="overlay open" style={{ zIndex: 9300 }}>
        <div className="modal modal-md">
          <div className="mhead">
            <h2>📋 Acceptation des conditions</h2>
            <button className="mclose" onClick={() => setAcceptModalFor(null)}>✕</button>
          </div>
          <div className="mbody">
            <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>
              Avant d'inviter <strong style={{ color: 'var(--text)' }}>{acceptModalFor.cnom}</strong> comme
              sous-compte FedaPay, confirmez qu'il a pris connaissance et accepté les conditions de commission
              de la Plateforme.
            </p>
            <div style={{ background: 'rgba(0,191,255,0.06)', border: '1px solid rgba(0,191,255,0.2)', borderRadius: 8, padding: '14px 16px', marginBottom: 14 }}>
              <div style={{ fontSize: 12.5, color: 'var(--text)', lineHeight: 1.7 }}>
                <strong>Taux de commission actuel : {commissionPct}%</strong> HT du montant brut de chaque
                transaction, prélevé automatiquement au moment du paiement. Le client reçoit directement le
                montant net ; les frais du prestataire de paiement (FedaPay) restent à la charge de
                KotosTechnology. Ce taux peut être modifié avec un préavis de 30 jours (voir Annexe —
                Clause de commission marketplace).
              </div>
            </div>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: 'var(--muted)', cursor: 'pointer' }}>
              <input
                type="checkbox" checked={acceptChecked}
                onChange={e => setAcceptChecked(e.target.checked)}
                style={{ width: 'auto', marginTop: 2 }}
              />
              Je confirme que le client a pris connaissance et accepté ces conditions de commission
              (par écrit, oralement ou via l'annexe contractuelle signée).
            </label>
            <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
              <button className="abtn abtn-muted" onClick={() => setAcceptModalFor(null)}>Annuler</button>
              <button
                className="abtn abtn-green"
                disabled={!acceptChecked}
                onClick={confirmerAcceptationEtInviter}
              >
                ✓ Confirmer et inviter maintenant
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
